import React from 'react';
import { Group, Pagination, Text } from '@mantine/core';

interface TablePaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  /** With these two, "Showing x to y of z results" is shown as well. */
  totalItems?: number;
  pageSize?: number;
}

/** Footer for a paginated table. Renders nothing when there is one page. */
const TablePagination = ({
  page,
  totalPages,
  onChange,
  totalItems,
  pageSize,
}: TablePaginationProps) => {
  const showSummary = totalItems !== undefined && pageSize !== undefined;
  if (totalPages <= 1 && !showSummary) return null;

  return (
    <Group justify="space-between" mt="md" wrap="wrap" gap="sm">
      {showSummary ? (
        <Text size="sm" c="dimmed">
          Showing {Math.min((page - 1) * pageSize! + 1, totalItems!)} to{' '}
          {Math.min(page * pageSize!, totalItems!)} of {totalItems} results
        </Text>
      ) : (
        <span />
      )}
      {totalPages > 1 && (
        <Pagination
          value={page}
          total={totalPages}
          onChange={onChange}
          size="sm"
        />
      )}
    </Group>
  );
};

export default TablePagination;
